export default function assemblePath(...pathParts: string[]): string {
  const nonEmptyParts = pathParts.filter(Boolean);
  if (nonEmptyParts.length < 1) {
    return '/';
  }
  return `/${nonEmptyParts.join('/')}/`;
}
